
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind6 as ObiWind6Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-6.js';
 
 
 

 
 export const ObiWind6 = createComponent({
   react: React,
   tagName: 'obi-wind-6',
   elementClass: ObiWind6Element,
   events: {
     
   }
  });
 
 